/** 칩 색상 */
const statusChipType = {
    ACCEPTED: {
        color: 'green lighten-4',
        textColor: 'green darken-4',
    },
    ALLOCATED: {
        color: 'primary lighten-4',
        textColor: 'primary darken-4',
    },
    PICKEDUP: {
        color: 'brown lighten-4',
        textColor: 'brown darken-4',
    },
    FINISHED: {
        color: 'blue-grey lighten-4',
        textColor: 'blue-grey darken-4',
    },
    CANCELED: {
        color: 'red lighten-4',
        textColor: 'red darken-4',
    },
};
/**
 * 모든 주문 상태
 * https://qc-zoo-client-api.barogo.io/docs/common/order-status.html
 */
export const orderStatus = {
    /** 예약 */
    RESERVED: {
        code: 'RESERVED',
        cssClass: 'reserved',
        value: 'common.reserved',
        statusChipType: '',
        group: 'accept',
    },
    /** 예약 종료? */
    RESERVE_END: {
        code: 'RESERVE_END',
        cssClass: 'reserve-end',
        value: 'common.reserve_end',
        statusChipType: '',
        group: '',
    },
    /** 재접수 */
    RE_ACCEPT: {
        code: 'RE_ACCEPT',
        cssClass: 're-accept',
        value: 'common.re_accept',
        group: '',
        statusChipType: '',
    },
    /** 접수 */
    ACCEPTED: {
        code: 'ACCEPTED',
        cssClass: 'accepted',
        value: 'common.accepted',
        statusChipType: statusChipType.ACCEPTED,
        group: 'accept',
    },
    /** 배차 요청 */
    WORKER_REQUESTED: {
        code: 'WORKER_REQUESTED',
        cssClass: 'worker-requested',
        value: 'common.accepted',
        statusChipType: statusChipType.ACCEPTED,
        group: 'accept',
        valueForTimeline: 'common.worker_requested',
    },
    /** 배차 요청을 보낸 쪽에서 취소함 */
    WORKER_REQUESTED_CANCEL: {
        code: 'WORKER_REQUESTED_CANCEL',
        cssClass: 'worker-requested-cancel',
        value: 'common.worker_requested_cancel',
        statusChipType: statusChipType.ACCEPTED,
        group: 'accept',
    },
    /** 즉배 (즉시 배차) */
    IMMEDIATE_ALLOCATE: {
        code: 'IMMEDIATE_ALLOCATE',
        cssClass: 'immediate-allocate',
        value: 'common.immediate_allocate',
        group: 'allocate',
    },
    /** 배차 */
    ALLOCATED: {
        code: 'ALLOCATED',
        cssClass: 'allocated',
        value: 'common.allocated',
        statusChipType: statusChipType.ALLOCATED,
        group: 'allocate',
    },
    /**
     * tg0825 20250108
     * 아래 상태는 안쓰이는 상태임 추가된 사유 찾기 어렵지만 결과적으로 쓰지 않는 것을 확인함
     * 라이더가 배차요청 거절시에 statusCode는 ACCEPTED이고 payloadType은 ALLOCATE_REJECT임.
     * 나중에 리팩토링시에 제거하기로 하고 일단은 유지하기로 함
     * 관련 링크: https://barogo.slack.com/archives/C04UP4VFCKA/p1736380803785889
     *
     * 배차거절 (배차요청을 라이더가 거절함)
     * */
    ALLOCATE_REJECTED: {
        code: 'ALLOCATE_REJECTED',
        cssClass: 'allocate-rejected',
        value: 'common.allocate_rejected',
        statusChipType: statusChipType.ACCEPTED,
        group: 'accept',
    },
    /** 배차 취소 (허브에서 취소함) */
    ALLOCATE_CANCEL: {
        code: 'ALLOCATE_CANCEL',
        cssClass: 'allocate-cancel',
        value: 'common.allocate_cancel',
        group: 'accept',
    },
    /** 우선 배차 */
    PRIORITY_ALLOCATE: {
        code: 'PRIORITY_ALLOCATE',
        cssClass: 'PRIORITY_ALLOCATE',
        value: 'common.priority_allocate',
        group: '',
    },
    /** 우선 배차 취소 */
    PRIORITY_ALLOCATE_CANCEL: {
        code: 'PRIORITY_ALLOCATE_CANCEL',
        cssClass: 'priority-allocate-cancel',
        value: 'common.priority_allocate_cancel',
        group: '',
    },
    /** 픽업 */
    PICKUP: {
        code: 'PICKUP',
        cssClass: 'pickup',
        value: 'common.pickup',
        group: '',
    },
    /** 픽업 도착 */
    PICKUP_ARRIVED: {
        code: 'PICKUP_ARRIVED',
        cssClass: 'pickup-arrived',
        value: 'common.pickup_arrived',
        statusChipType: statusChipType.ALLOCATED,
        group: 'allocate',
    },
    /** 픽업 완료 */
    PICKUP_FINISHED: {
        code: 'PICKUP_FINISHED',
        cssClass: 'pickup-finished',
        value: 'common.pickup_finished',
        statusChipType: statusChipType.PICKEDUP,
        group: 'pickup',
    },
    /** 완료 (고객에게 배달 도착 함) */
    DROP_FINISHED: {
        code: 'DROP_FINISHED',
        cssClass: 'drop-finished',
        value: 'common.drop_finished',
        statusChipType: statusChipType.FINISHED,
        group: 'finish',
    },
    /** 취소 */
    CANCELED: {
        code: 'CANCELED',
        cssClass: 'canceled',
        value: 'common.cancel',
        statusChipType: statusChipType.CANCELED,
        group: 'finish',
    },
    /** 주문..?? */
    ORDER: {
        code: 'ORDER',
        cssClass: 'order',
        value: 'common.order',
        group: '',
    },
    ORDER_REJECT: {
        code: 'ORDER_REJECT',
        cssClass: 'order-reject',
        value: 'common.order_reject',
        group: '',
    },
    /** 주문 수정 */
    ORDER_MODIFY: {
        code: 'ORDER_MODIFY',
        cssClass: 'order-modify',
        value: 'common.order_modify',
        group: '',
    },
    /** 자체 */
    SELF: {
        code: 'SELF',
        cssClass: 'orange',
        value: 'common.self',
        group: 'self',
    },
    /** 자체 배달 */
    SELF_DELIVERY: {
        code: 'SELF_DELIVERY',
        cssClass: 'orange',
        value: 'common.self_delivery',
        group: 'self',
    },
    /** 자체 배달 중 */
    SELF_DELIVERING: {
        code: 'SELF_DELIVERING',
        cssClass: 'orange',
        value: 'common.self_delivering',
        group: 'self',
    },
    /** 자체 배달 완료 */
    SELF_DROP_FINISHED: {
        code: 'SELF_DROP_FINISHED',
        cssClass: 'self-drop-finished',
        value: 'common.self_drop_finished',
        group: '',
    },
    /** 그외 */
    ALL: {
        code: 'ALL',
        cssClass: 'all',
        value: 'common.all',
        group: '',
    },
    NONE: {
        code: 'NONE',
        cssClass: 'none',
        value: '',
    },
    // 상세이력에서 사용
    // https://www.notion.so/barogohq/d575a8fe27ca499daf1fdcedb3b35266?v=d90fe807e13a45f3a3e5443b393985a6
    QUESTION: {
        code: 'QUESTION',
        cssClass: 'question',
        value: 'common.question',
        group: '',
    },
    SETTLED: {
        code: 'SETTLED',
        cssClass: 'settled',
        value: 'common.settled',
        group: 'finish',
    },
    /** 대기? */
    WAITED: {
        code: 'WAITED',
        cssClass: 'waited',
        value: 'common.waited',
        group: '',
    },
    /** 대기 종료? */
    WAIT_END: {
        code: 'WAIT_END',
        cssClass: 'wait-end',
        value: 'common.wait_end',
        group: '',
    },
};
export const orderStatusWithAll = Object.assign(orderStatus, {
    ALL: {
        code: 'ALL',
        value: 'common.all',
        group: '',
    },
});
